import * as Yup from "yup";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { AdminHeader } from "shared/components/common/AdminHeader";
import { Loading } from "shared/components/ui/Loading";
import { useGetVersionQuery } from "shared/redux/endpoints/admin";

const versionSchema = Yup.object().shape({
  version: Yup.string().required(),
  time: Yup.string().required(),
});

export default function VersionPage() {
  const { data, isLoading } = useGetVersionQuery();
  const hasValidData = versionSchema.isValidSync(data);

  return (
    <DashboardLayout>
      <AdminHeader />
      <DashboardNavbar light />
      <MDBox className="container-lxo-management container-lxo-detail">
        {isLoading ? (
          <MDBox
            display="flex"
            justifyContent="center"
            alignItems="center"
            width="100%"
            height={300}
          >
            <Loading style={{ width: 150, height: 100 }} />
          </MDBox>
        ) : hasValidData ? (
          <MDBox className="header-lxo-task">
            <MDBox className="group-title">
              <MDTypography
                className="title-main"
                style={{ textTransform: "none", fontWeight: 600 }}
              >
                Current version:{" "}
                <span style={{ textDecoration: "underline" }}>
                  {data.version}
                </span>{" "}
                <br />
                Build time:{" "}
                <span style={{ textDecoration: "underline" }}>{data.time}</span>
              </MDTypography>
            </MDBox>
          </MDBox>
        ) : (
          <MDBox
            display="flex"
            justifyContent="center"
            alignItems="center"
            height={300}
          >
            <MDTypography color="error">
              Failed to load version information.
            </MDTypography>
          </MDBox>
        )}
      </MDBox>
    </DashboardLayout>
  );
}
